<template>
  <div class="block-chain-archiving">
    <detail-table
      title="归档数据详情"
      :show-border="true"
      :table-col="tableCol"
      :list="tableData"
      :show-inner-actions="true"
    >
      <div slot="inner-actions">
        <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
      </div>
    </detail-table>
    <detail-section
      v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.dataArchiving.search)"
      title="数据归档查询"
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="rules"
        :label-width="`${adaptationVars.formLabelWidth}px`"
        class="archiving-query-form"
      >
        <el-form-item label="数据库IP" prop="ip">
          <el-input v-model="dataForm.ip" placeholder="请输入数据库IP"></el-input>
        </el-form-item>
        <el-form-item label="数据库端口" prop="port">
          <el-input v-model="dataForm.port" placeholder="请输入数据库端口"></el-input>
        </el-form-item>
        <el-form-item label="数据库用户名" prop="user">
          <el-input v-model="dataForm.user" placeholder="请输入数据库用户名"></el-input>
        </el-form-item>
        <el-form-item label="数据库密码" prop="pwd">
          <el-input v-model="dataForm.pwd" placeholder="请输入数据库密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <el-input v-model="queryValue" placeholder="请输入内容" class="input-with-select" clearable>
        <el-select
          slot="prepend"
          v-model="queryType"
          placeholder="请选择查询类型"
          class="type-select"
        >
          <el-option
            v-for="item in queryTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button slot="append" type="primary" @click="archivingQuery">搜索</el-button>
      </el-input>
    </detail-section>
    <create-archiving
      ref="createArchiving"
      :total-block-height="numObj.blockHeight"
      @createSuccess="refresh"
    ></create-archiving>
    <archiving-restore
      ref="archivingRestore"
      :total-archiving-height="tableData.dumpedHeight"
      @restoreSuccess="refresh"
    ></archiving-restore>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import auth from '@/auth/index'
import { mapActions } from 'vuex'
import createArchiving from './createArchiving'
import archivingRestore from './archivingRestore'
import heightImg from '@/assets/images/tableIcon/height.png'

export default {
  name: 'Index',
  components: {
    createArchiving,
    archivingRestore
  },
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '新建数据归档',
          click: () => {
            return this.handleCreateArchiving()
          },
          icon: 'icon-add',
          auth: auth.blockchain.checkDetail.dataArchiving.create
        },
        {
          btnContent: '归档数据恢复',
          click: () => {
            return this.handleArchivingRestore()
          },
          icon: 'icon-restore',
          auth: auth.blockchain.checkDetail.dataArchiving.restore
        }
      ],
      tableCol: [
        {
          label: '已归档数据区块高度',
          icon: heightImg,
          value: 'dumpedHeight',
          formatter: (data, value) => {
            return data[value]
          }
        }
      ],
      tableData: {
        dumpedHeight: 0
      },
      queryValue: '',
      queryType: 1,
      queryTypeOptions: [
        {
          value: 1,
          label: '区块高度'
        },
        {
          value: 2,
          label: '区块哈希'
        },
        {
          value: 3,
          label: '交易ID'
        }
      ],
      numObj: {},
      dataForm: {
        ip: '',
        port: '',
        user: '',
        pwd: ''
      },
      rules: {
        ip: [
          { required: true, message: '请输入数据库IP', trigger: ['blur', 'change'] },
          {
            pattern: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
            message: '请输入有效的IP地址',
            trigger: ['blur', 'change']
          }
        ],
        port: [
          { required: true, message: '请输入数据库端口', trigger: ['blur', 'change'] },
          { pattern: /^[1-9]\d{0,4}$/, message: '请输入有效的端口 ', trigger: ['blur', 'change'] }
        ],
        user: [{ required: true, message: '请输入数据库用户名', trigger: ['blur', 'change'] }],
        pwd: [{ required: true, message: '请输入数据库密码', trigger: ['blur', 'change'] }]
      },
      auth: auth,
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {
    let cid = this.$route.query.chainId
    let details = {}
    try{
      details = JSON.parse(this.$route.query.detail)
    } catch(e) {
      console.log(e)
    }
    if(details.Healthy) {
      this.getProfile(cid)
      this.getData(cid)
    }
    this.loadServerMem()
  },
  methods: {
    ...mapActions(['updateArchivingInfo']),
    loadServerMem() {
      let sInfoStr = localStorage.getItem('cbaas_blockchain_archiving_server')
      let sInfo = {}
      if (sInfoStr) {
        try {
          sInfo = JSON.parse(sInfoStr)
        } catch (e) {
          console.log(e)
        }
      }
      this.dataForm.ip = sInfo.ip
      this.dataForm.port = sInfo.port
      this.dataForm.user = sInfo.user
      this.dataForm.pwd = sInfo.pwd
    },
    handleCreateArchiving() {
      this.$refs.createArchiving.handleOpen()
    },
    handleArchivingRestore() {
      this.$refs.archivingRestore.handleOpen()
    },
    archivingQuery() {
      let self = this
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          console.log('submit!!')
          if (self.queryValue) {
            let params = {
              chainid: self.$route.query.chainId,
              db_info: {
                ip: self.dataForm.ip,
                port: self.dataForm.port,
                user: self.dataForm.user,
                pwd: self.dataForm.pwd
              }
            }
            localStorage.setItem(
              'cbaas_blockchain_archiving_server',
              JSON.stringify(params.db_info)
            )
            let apiName = 'queryByHeight'
            if (self.queryType == 1) {
              apiName = 'queryByHeight'
              params.height = parseInt(self.queryValue)
            } else if (self.queryType == 2) {
              apiName = 'queryByHash'
              params.hash = self.queryValue
            } else if (self.queryType == 3) {
              apiName = 'queryByTxID'
              params.tx_id = self.queryValue
            }
            self.$apis.chain[apiName](params)
              .then(data => {
                if (!data.errors) {
                  let result = JSON.parse(data.data)
                  result.db_info = params.db_info
                  this.updateArchivingInfo(result)
                  self.$message.success('查询成功')

                  this.$router.push({
                    name: 'archivingDetail',
                    query: {
                      chainId: self.$route.query.chainId
                    }
                  })
                }
              })
              .catch(err => {
                console.log(err)
              })
          } else {
            self.$message.success('请输入内容用以查询')
          }
        } else {
          console.log('error submit!!')
        }
      })
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.create_time)
    },
    refresh() {
      console.log('refresh')
      let cid = this.$route.query.chainId
      this.getProfile(cid)
      this.getData(cid)
      this.loadServerMem()
    },
    getProfile(cid) {
      let self = this
      this.$apis.chain
        .getProfile({
          chainid: cid
        })
        .then(data => {
          if (!data.errors) {
            self.tableData.dumpedHeight = data.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getData(cid) {
      if (cid) {
        this.$apis.home.getOverview({ cid }).then(res => {
          if (res.data) {
            this.numObj = res.data
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('block-chain-archiving-details', (), ());

.block-chain-archiving {
  @include adaptation(
    (
      --block-chain-archiving-detail-section-padding: 4px 0,
      --block-chain-archiving-detail-section-content-padding: 4px 0 12px,
      --block-chain-archiving-query-form-width: 650px,
      --block-chain-archiving-type-select-width: 120px
    )
  );

  .cbaas-detail-table {
    /deep/ .cbaas-detail-section {
      padding: var(--block-chain-archiving-detail-section-padding);

      .content {
        padding: var(--block-chain-archiving-detail-section-content-padding);
      }
    }
  }

  .cbaas-detail-section {
    padding: var(--block-chain-archiving-detail-section-padding);
  }

  .archiving-query-form {
    width: var(--block-chain-archiving-query-form-width);
  }

  .input-with-select {
    width: var(--block-chain-archiving-query-form-width);

    .type-select {
      width: var(--block-chain-archiving-type-select-width);
    }

    /deep/ {
      .el-input-group__append {
        padding: 0;
        
        .el-button {
          margin: 0;
        }
      }
    }
  }
}
</style>
